import { useDocument, type UseDocumentProps } from '@ztechapps/common.hook'
import type { Logistic } from '@ztechapps/common.contract'
import { singleLogisticQuery } from './graphql'
import { useLogisticIdParam } from './useLogisticIdParam'

export const useLogisticDocument = ({ query, ...props } = {} as Partial<UseDocumentProps>) => {
  const logisticId = useLogisticIdParam()

  const defaultQuery = query ?? singleLogisticQuery

  return useDocument<Logistic>({ query: defaultQuery, _id: logisticId, ...props })
}
